import React from 'react';
import { PropTypes } from 'prop-types';
import { Text, Divider } from 'rsuite';
import {
  PresentationGrid,
  PresentationRow,
  PresentationCol,
} from '../../layout/PresentationLayout';
import { formatPhoneNumber } from './helper';
import { titleize } from '../../../common/utils';

const PropertyContact = ({ data, roles }) => {
  return (
    <PresentationGrid
      fluid
      className="property-contact content-section"
    >
      <PresentationRow className="mb-4">
        <PresentationCol
          xs={24}
          sm={12}
          md={12}
          lg={12}
        >
          <Text className="text-extra-large text-bold mb-4">{data?.name}</Text>
          {data.companyName && (
            <Text className="text-large">{data?.companyName}</Text>
          )}
        </PresentationCol>
        <PresentationCol
          xs={12}
          sm={12}
          md={12}
          className="pt-16-sm"
        >
          {roles.map((role, i) => (
            <PresentationRow
              key={i}
              className="mb-4"
            >
              <PresentationCol
                xs={24}
                className="contact-right-align"
              >
                <Text className="grey-text">{role}</Text>
              </PresentationCol>
            </PresentationRow>
          ))}
        </PresentationCol>
      </PresentationRow>
      <PresentationRow>
        <PresentationCol xs={24}>
          <Divider style={{ margin: '15px 0px' }} />
        </PresentationCol>
      </PresentationRow>
      <PresentationRow className="mb-16">
        <PresentationCol xs={24}>
          <Text className="grey-text">Mailing Address</Text>
          <Text className="text-large">{titleize(data?.address)}</Text>
        </PresentationCol>
      </PresentationRow>
      <PresentationRow>
        <PresentationCol
          xs={24}
          sm={16}
          className="pb-16-sm"
        >
          <Text className="grey-text">Email Address</Text>
          <a
            className="text-large"
            style={{ wordBreak: 'break-word', color: 'unset' }}
            href={`${data?.email}`}
          >
            {data?.email}
          </a>
        </PresentationCol>
        <PresentationCol
          xs={24}
          sm={8}
          className="pb-16-sm contact-right-align"
        >
          <Text className="grey-text contact-phone">Phone</Text>
          <Text className="text-large">
            {formatPhoneNumber(data?.primaryPhone)}
          </Text>
        </PresentationCol>
      </PresentationRow>
    </PresentationGrid>
  );
};

PropertyContact.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    companyName: PropTypes.string,
    address: PropTypes.string,
    email: PropTypes.string,
    primaryPhone: PropTypes.string,
  }).isRequired,
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default PropertyContact;
